import type { CustomRequired } from "~/@types/utility-types";
import { PremiumAppealBanner } from "~/components/templates/common/purchase-modal/purchase-premium-appeal-banner/premium-appeal-banner";
import { selectBannerParams } from "~/components/templates/common/purchase-modal/purchase-premium-appeal-banner/select-banner-params";
import type { G_FetchVideoContentQuery, G_VideoSvodProduct, Maybe } from "~/lib/graphql";
import { G_ServicePlan } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

type Args = {
  isLimitedPremium: boolean;
  svodProduct: Maybe<Pick<G_VideoSvodProduct, "contentId">> | undefined;
  ppvProducts?: CustomRequired<G_FetchVideoContentQuery["videoContent"]>["ppvProducts"];
};

export const PurchasePremiumAppealBanner = (args: Args) => {
  const { servicePlan, isLoggedIn, isFirstSubscribe } = useAuth();
  const { isLimitedPremium, svodProduct, ppvProducts } = args;
  const isSvodProduct = svodProduct !== null && svodProduct !== undefined;
  const isPpv = ppvProducts !== null && ppvProducts !== undefined && ppvProducts.length !== 0;

  const isPremiumMemberBefore = isLoggedIn && !isFirstSubscribe;
  // 併売フラグ
  const isDualSalesModel = isSvodProduct && isPpv;

  if (servicePlan === G_ServicePlan.Premium) return null;

  const currentHref = location.href;

  const bannerTexts = selectBannerParams({
    isLimitedPremium,
    isDualSalesModel,
    isPremiumMemberBefore,
    currentHref,
  });
  if (!bannerTexts) return null;

  const { firstLineMainText, secondLineMainText, topSubText, bottomSubText, buttonText, onClickBanner, onMountBanner } =
    bannerTexts;

  return (
    <PremiumAppealBanner
      firstLineMainText={firstLineMainText}
      secondLineMainText={secondLineMainText}
      topSubText={topSubText}
      bottomSubText={bottomSubText}
      buttonText={buttonText}
      onClickBanner={onClickBanner}
      onMountBanner={onMountBanner}
    />
  );
};
